<section class="terminal-lookup">
    <!-- Search Card -->
    <div class="card m-b-20">
        <div class="card-header">
            <i class="fa fa-search label-icon" aria-hidden="true"></i>
            <label class="p-l-5 m-b-0">Terminal Lookup</label>
        </div>
        <div class="card-body">
            <div class="row align-items-end">
                <div class="col-sm-5">
                    <label for="serial-input">Enter Serial Number:</label>
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        [class.is-invalid]="errorMessage"
                        id="serial-input"
                        [(ngModel)]="serialInput"
                        placeholder="Enter Terminal Serial Number to search..."
                        (keyup.enter)="search()"
                    />
                    <small *ngIf="errorMessage" class="text-danger d-block m-t-5">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{errorMessage}}
                    </small>
                </div>
                <div class="col-sm-3 p-t-5">
                    <button class="btn btn-info btn-sm" type="button" (click)="search()" [disabled]="isLoading">
                        <i class="fa" [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-search'" aria-hidden="true"></i>
                        {{ isLoading ? 'Searching...' : 'Search' }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Loading Indicator -->
    <div *ngIf="isLoading" class="text-center m-t-30 m-b-30">
        <i class="fa fa-spinner fa-spin fa-2x text-muted"></i>
        <p class="text-muted m-t-10">Searching...</p>
    </div>

    <!-- No Results -->
    <div *ngIf="searchPerformed && !terminalInfo && !isLoading" class="card">
        <div class="card-body text-center p-30">
            <i class="fa fa-search fa-2x text-muted"></i>
            <h5 class="text-muted m-t-10">No Terminal found</h5>
            <p class="text-muted m-b-0">No results found for Serial Number: <strong>{{serialInput}}</strong></p>
        </div>
    </div>

    <!-- Results -->
    <div *ngIf="terminalInfo && !isLoading">
        <!-- Hierarchy Summary Row -->
        <div class="row top-stat m-b-20">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <i class="fa fa-briefcase label-icon label-head-icon" aria-hidden="true"></i>
                        <label class="p-l-5">Business:</label>
                        <label class="detail-label">{{businessInfo?.xName || '...'}}</label>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <i class="fa fa-map-marker label-icon label-head-icon" aria-hidden="true"></i>
                        <label class="p-l-5">Store:</label>
                        <label class="detail-label">{{storeInfo?.xName || '...'}}</label>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <i class="fa fa-building-o label-icon label-head-icon" aria-hidden="true"></i>
                        <label class="p-l-5">Profit Center:</label>
                        <label class="detail-label">{{profitCenterInfo?.xName || '...'}}</label>
                    </div>
                </div>
            </div>
            <!-- <div class="col">
                <div class="card">
                    <div class="card-body">
                        <i class="fa fa-terminal label-icon label-head-icon" aria-hidden="true"></i>
                        <label class="p-l-5">Terminal:</label>
                        <label class="detail-label">{{terminalInfo.xName || terminalInfo.xRegSerNum}}</label>
                    </div>
                </div>
            </div> -->
        </div>

        <!-- Detail Cards -->
        <div class="row">
            <!-- Terminal Details -->
            <div class="col-sm-8">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-level-up label-icon fa-flip-horizontal" aria-hidden="true"></i>
                        <label class="p-l-5 m-b-0">Terminal Details</label>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">Name:</label>
                                    <p class="lookup-value">{{terminalInfo.xName || '-'}}</p>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">Serial Number:</label>
                                    <p class="lookup-value">{{terminalInfo.xRegSerNum || '-'}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">GMID:</label>
                                    <p class="lookup-value"><strong>{{profitCenterInfo.xGMID || '-'}}</strong></p>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">GTID:</label>
                                    <p class="lookup-value"><strong>{{terminalInfo.xGTID || '-'}}</strong></p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">Terminal Number:</label>
                                    <p class="lookup-value">{{terminalInfo.xTermNum || '-'}}</p>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">Short Code:</label>
                                    <p class="lookup-value">{{terminalInfo.xShortCode || '-'}}</p>
                                </div>
                            </div>
                        </div> -->
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">Status:</label>
                                    <p class="lookup-value">
                                        <span class="badge" [ngClass]="terminalInfo.xStatus === 1 ? 'badge-success' : 'badge-danger'">
                                            {{terminalInfo.xStatus === 1 ? 'Active' : 'Inactive'}}
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">GMPW:</label>
                                    <p class="lookup-value">{{profitCenterInfo?.xGMPW || '-'}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">Notes:</label>
                                    <p class="lookup-value">{{terminalInfo.xNotes || '-'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Column -->
            <div class="col-sm-4">
                <!-- Profit Center Card -->
                <div class="card m-b-15">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <span>
                            <i class="fa fa-building-o label-icon" aria-hidden="true"></i>
                            <label class="p-l-5 m-b-0">Profit Center</label>
                        </span>
                        <button
                            class="btn btn-default btn-sm"
                            type="button"
                            (click)="navigateToProfitCenter()"
                            [disabled]="!terminalInfo.xMainPCtrID || profitCenterInfo?.xStatus !== 1"
                            tooltip="Go to Profit Center"
                            placement="left"
                            container="body"
                            containerClass="tooltip-global"
                        >
                            <i class="fa fa-external-link" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div class="card-body">
                        <p class="m-b-5"><span class="text-muted">Name: </span>{{profitCenterInfo?.xName || '-'}}</p>
                        <p *ngIf="profitCenterInfo?.xPCtrNum" class="m-b-5"><span class="text-muted">Profit Center #: </span>{{profitCenterInfo.xPCtrNum}}</p>
                        <p class="text-muted small m-b-0">ID: {{terminalInfo.xMainPCtrID || '-'}}</p>
                    </div>
                </div>

                <!-- Store Card -->
                <div class="card m-b-15">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <span>
                            <i class="fa fa-map-marker label-icon" aria-hidden="true"></i>
                            <label class="p-l-5 m-b-0">Store</label>
                        </span>
                        <button
                            class="btn btn-default btn-sm"
                            type="button"
                            (click)="navigateToStore()"
                            [disabled]="!terminalInfo.xStoreID || storeInfo?.xStatus !== 1"
                            tooltip="Go to Store"
                            placement="left"
                            container="body"
                            containerClass="tooltip-global"
                        >
                            <i class="fa fa-external-link" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div class="card-body">
                        <p class="m-b-5"><span class="text-muted">Name: </span>{{storeInfo?.xName || '-'}}</p>
                        <p *ngIf="storeInfo?.xStoreNum" class="m-b-5"><span class="text-muted">Store #: </span>{{storeInfo.xStoreNum}}</p>
                        <p class="text-muted small m-b-0">ID: {{terminalInfo.xStoreID || '-'}}</p>
                    </div>
                </div>

                <!-- Business Card -->
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <span>
                            <i class="fa fa-briefcase label-icon" aria-hidden="true"></i>
                            <label class="p-l-5 m-b-0">Business</label>
                        </span>
                        <button
                            class="btn btn-default btn-sm"
                            type="button"
                            (click)="navigateToBusiness()"
                            [disabled]="!terminalInfo.xBusinessID || businessInfo?.xStatus !== 1"
                            tooltip="Go to Business"
                            placement="left"
                            container="body"
                            containerClass="tooltip-global"
                        >
                            <i class="fa fa-external-link" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div class="card-body">
                        <div *ngIf="businessInfo">
                            <p class="m-b-5"><span class="text-muted">Name: </span>{{businessInfo.xName || '-'}}</p>
                            <p *ngIf="businessInfo.xBusinessNum" class="m-b-5"><span class="text-muted">Business #: </span>{{businessInfo.xBusinessNum}}</p>
                            <p class="text-muted small m-b-0">ID: {{terminalInfo.xBusinessID || '-'}}</p>
                        </div>
                        <p *ngIf="!businessInfo" class="text-muted m-b-0">Loading...</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
